import React from 'react';
import { IconButton, List, ThemeProvider, Typography } from '@mui/material';
import { buttonsTheme } from './_theme.jsx';
import Drawer from '@mui/material/Drawer';
import CloseIcon from '@mui/icons-material/Close';
import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import Skeleton from '@mui/material/Skeleton';
import Grid from '@mui/material/Grid';

// prettier-ignore
/**
 *
 * @param {boolean} isOpen
 * @param {boolean} isFormInvalid
 * @param {string} helpWhenInvalid
 * @param {function(boolean): void} toggleDrawer
 * @param {function(): *} getFilterList
 * @param {function(React.SyntheticEvent): void} onApply
 * @param {*} data
 * @returns {React.ReactElement}
 */
export function getFilterDrawer(isOpen, isFormInvalid, helpWhenInvalid, toggleDrawer, getFilterList, onApply, data) {
    return (
        <div>
            <React.Fragment>
                <ThemeProvider theme={buttonsTheme}>
                    <Drawer
                        open={isOpen}
                        anchor={"right"}
                        PaperProps={{
                            style: {
                                width: '450px',
                                height: 'calc(100% - 87px)',
                                top: '87px',
                                backgroundColor: "#f8f8f9"
                            }
                        }}
                        BackdropProps={{invisible: true}}
                        ModalProps={{onBackdropClick: toggleDrawer(false)}}
                    >
                        <div style={{display: 'grid', gridTemplateColumns: '1fr', gridTemplateRows: '90px 1fr 90px', height: '100%', zIndex: 1}}>
                        <div style={{
                            color: "white",
                            position: 'sticky',
                            padding: '4px 0px',
                            top: 0,
                            zIndex: 1,
                            backgroundColor: "#F19001",
                            height: '80px',
                            width: '100%',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <IconButton onClick={toggleDrawer(false)} size='large'
                                        sx={{marginLeft: '.5vw', color: 'white'}}>
                                <CloseIcon sx={{fontSize: '24px'}}/>
                            </IconButton>
                            <div>
                                <Typography variant='h5' sx={{marginLeft: '8px'}}>Filters</Typography>
                            </div>
                        </div>
                        {Object.keys(data).length > 0 ?

                            <React.Fragment>
                                <Box style={{zIndex: 0, overflow: 'scroll'}}>
                                    {getFilterList()}
                                </Box>

                                <List style={{marginTop: `auto`}}>
                                    <Divider/>
                                    <Box
                                        m={2}
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                    >
                                        <Tooltip
                                            title={isFormInvalid ? helpWhenInvalid : ''}
                                            placement={'top'} arrow
                                        >
                                    <span>
                                        <Button variant='contained' color='primary' onClick={onApply} disabled={isFormInvalid}>
                                            Apply
                                        </Button>
                                    </span>
                                        </Tooltip>
                                        <Button style={{marginLeft: '8px'}} variant='outlined' color='secondary' onClick={toggleDrawer(false)}>
                                            Cancel
                                        </Button>
                                    </Box>
                                </List>
                            </React.Fragment>

                        :   <Box sx={{ p: 2 }}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <Skeleton variant="rounded" width={418} height={50} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Skeleton variant="rounded" width={418} height={50} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Skeleton variant="rounded" width={418} height={50} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Skeleton variant="rounded" width={418} height={50} />
                                    </Grid>
                                </Grid>
                            </Box>
                        }
                        </div>
                    </Drawer>
                </ThemeProvider>
            </React.Fragment>
        </div>
    );
}
